import React from 'react'
import { Input, Button, message } from 'antd'
import BatchCheckModal from "./BatchCheckModal";
import Tools from '../tools/Tools'
import WWTable from "../components/Table"
import wwConstants from "../configs/wwConstants"
const TextArea = Input.TextArea;
class AddDeviceList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imei: '',
            imeiSet: [],
            deviceData: [],
            batchImei: '',
            batchLength: 0,
            error: true,
            imeis: '',
            hasList: '',
        };
        this.handleBatchImei = this.handleBatchImei.bind(this);
        this.handleImeiSet = this.handleImeiSet.bind(this);
        this.getBatchImei = this.getBatchImei.bind(this);
        this.deleteDevice = this.deleteDevice.bind(this);
        this.handleVisibleChange = this.handleVisibleChange.bind(this);
        this.getImeiSet = this.getImeiSet.bind(this);
        this.setDeviceData = this.setDeviceData.bind(this);
        self.addDeviceList = this;
        window.resetAddDeviceListStateInfo = this.resetAddDeviceListStateInfo.bind(this);
        this.addDevices = this.addDevices.bind(this)

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.record !== this.state.record) {
            this.setState({
                record: nextProps.record,
                deviceData:nextProps.record
            }, () => {
            })
        }
    }
    componentDidMount() {
    }

    resetAddDeviceListStateInfo() {
        this.setState({
            imei: '',
            imeiSet: [],
            deviceData: [],
            batchImei: '',
            batchLength: 0,
            imeis:''
        })
    }

    setDeviceData(imeis) {
        if (imeis.length>0) {
            this.setState({
                imeiSet: imeis
            }, () => {
                this.getBatchImei();
            })
        }
    }

    addDevices(imeis,isInitAdd) {
        if (!imeis.length){
            return
        }
        const {imeiSet} = this.state
        let newImeiSet = JSON.parse(JSON.stringify(imeiSet)).concat(imeis)
        this.setState({
            imeiSet: newImeiSet
        }, () => {
            this.getBatchImei(false,isInitAdd);
        })
    }

    deleteDevice(index) {
        return () => {
            let data = JSON.parse(JSON.stringify(this.state.deviceData));
            let imeiSet = JSON.parse(JSON.stringify(this.state.imeiSet));
            let imei = data[index].imei;
            data.splice(index, 1);
            let ImeiIndex ;
            imeiSet.map(function (item,i) {
                if(item == imei) {
                    ImeiIndex = i
                }
            })
            imeiSet.splice(ImeiIndex, 1);
            let imeis = imeiSet.join("\n")
            this.setState({
                deviceData: data,
                imeiSet:imeiSet,
                imeis:imeis
            }, () => {
                if(this.props.isInstruct) {
                    this.props.handleDelete && this.props.handleDelete(imei)
                } else {
                    this.getImeiSet()
                }

            })
        }
    }

    handleBatchImei(e) {
        let imei = e.target.value;
        this.setState({
            batchImei: imei
        })
    }

    //批量转移imei
    handleImeiSet(e) {
        // let imeiSet = e.target.value.trim().split(new RegExp("[^a-z0-9]"));//按字符串中的不为数字的标识分割数组

        let imeiSet = e.target.value.trim().split(/[\n\s+,\s+，]/g);//按空格、换行符、逗号分隔符正则表达式 分割数组
        this.setState({
            imeiSet: imeiSet,
            imeis:e.target.value
        })
    }

    getBatchImei(isPropsAdd,isInitAdd) {
        let that = this;
        let verification = false;
        if (!this.state.imeiSet.length) {
            message.warning(Strings.rs10409)
            return;
        }
        let array = [];
        this.state.imeiSet.forEach(function (item, index) {
            if (!wwConstants.checkGoomeRegExp.isNumber(item)) {
                verification = true;
            }
            if(!Tools.isNull(item)){
                array.push(item.trim())
            }
        });

        if (this.props.max == 500) {
            if (array.length > 500) {
                message.warning(Strings.rs10410)
                return
            }
        } else {
            if (array.length > 5000) {
                message.warning(Strings.rs14311)
                return
            }
        }

        let modal = {
            imeiSet:array,
            type:15
        }
        let type = Tools.isDeviceMgt(this.props.platform)?this.props.type:""
        let url = `${Tools.getApiUrl("batchCheck", this.props.platform)}${type}`
        Tools.fetch(url,'POST',array,function (data) {
            const {successDevices, errorDevices} = data.data
            if (successDevices) {
                !isPropsAdd && that.setState({
                    hasList:true
                })
                let deviceData = that.state.deviceData.concat(successDevices);
                let hash = {};
                deviceData = deviceData.reduce(function (item, next) {
                    hash[next.imei] ? '' : hash[next.imei] = true && item.push(next);
                    return item
                }, []);
                that.setState({
                    deviceData: deviceData,
                    visible: false
                }, () => {
                    if(isPropsAdd && !deviceData.length) {
                        message.error(Strings.rs10424)
                        return;
                    }

                    that.getImeiSet(isPropsAdd)
                })
            }
            if(errorDevices && errorDevices.length) {
                that.refs.batchCheck.showModal(errorDevices,successDevices)
                if(that.props.isInstruct) {
                    errorDevices.map(function (imei) {
                        that.props.handleDelete && that.props.handleDelete(imei)
                    })
                }
            }
        })
    }

    handleVisibleChange(visible) {
        this.setState({visible});
    }

    getImeiSet(isPropsAdd) {
        let imeiSet = [];
        this.state.deviceData.forEach(function (item) {
            imeiSet.push(item.imei);
        });
        this.props.handleImeiSet(imeiSet,isPropsAdd);
    }

    render() {
        let that = this;
        const {hasList} = this.state;
        const {hideTable,max} = this.props;
        const columns = [
            {
            title: Strings.rs10181,
            dataIndex: 'name',
            width: '25%'
        }, {
            title: Strings.rs10084,
            dataIndex: 'imei',
            width: '25%'
        }, {
            title: Strings.rs10034,
            dataIndex: 'accountName',
            width: '20%'
        }, {
            title: Strings.rs10106,
            dataIndex: 'useStatus',
            width: '20%',
            render:function(text, record, index){
                let useStatus = record.useStatus;
                let useText = "";

                switch (useStatus) {
                    case 0:
                        useText = Strings.rs10110;
                        break;
                    case 1:
                        useText = Strings.rs10182;
                        break;
                    case 3:
                        useText = Strings.rs10183;
                        break;
                    case 5:
                        useText = Strings.rs10184;
                        break;
                    case 7:
                        useText = Strings.rs10185;
                        break;
                    case 9:
                        useText = Strings.rs10186;
                        break;

                }
                return useText;

            }
        }, {
            title: Strings.rs10091,
            dataIndex: '',
            width: '20%',
            render: function (text, record, index) {
                return <a onClick={that.deleteDevice(index)}>{Strings.rs10017}</a>
            }
        }];
        const columns_mic = [
            {
                title: Strings.carCode,
                dataIndex: 'carCode',
                width: '25%'
            },
            {
                title: Strings.imei,
                dataIndex: 'imei',
                width: '25%'
            },
            {
                title: Strings.orgName,
                dataIndex: 'orgName',
                width: '30%'
            },
            {
                title: Strings.rs10091 || Strings.opts,
                dataIndex: '',
                width: '20%',
                render: function (text, record, index) {
                    return <i title={Strings.rs10017} onClick={that.deleteDevice(index)} className={"icon blue iconfont icon-shanchu"}></i>
                }
            },
        ]
        let imeiLength = []
        this.state.imeiSet.forEach(function (item,index) {
            if(!Tools.isNull(item)){
                imeiLength.push(item)
            }
        })
        let deviceTitle;
        let error = this.props.error
        let dataSource = [];
        if (this.state.deviceData.length) {
            dataSource = this.state.deviceData;
        }
        return (
            <div>
                <div className="modal_item vtop">
                    <span className="form_span">{Strings.rs10174}</span>
                    <div  className="form_value text_area">
                        <TextArea className={"bigInputArea"}
                               key={this.props.changeAccountId}
                               rows={3}
                               value={this.state.imeis}
                                style={{ resize: 'none'}}
                               onChange={this.handleImeiSet}/>
                        <Button type={"primary"} onClick={()=>this.getBatchImei(false)}>{Strings.rs10009}</Button>
                    </div>
                </div>
                <div className="modal_item">
                    <span className="form_span null_span"></span>
                    <div  className="form_value">
                        <div className={"desc"}>{max==500?Strings.rs14201:Strings.rs14312 || "Input IMEI numbers separated by comma, space, or line break. The length of IMEI should be 12 or 15 digits. Up to 5000 IMEI numbers can be input once."}</div>
                    </div>
                </div>
                <span className='import-device-desc'
                      style={{ display: this.props.error && this.props.threeDele == '-1' ? 'inline-block' : 'none', paddingLeft: '146px' }}>{Strings.rs12316}:<a style={{ color: '#f04134' }} onClick={() => window.open(this.props.errorFileUrl)}>{Strings.rs12318}</a></span>
                {!hideTable || hasList?<div className="modal_item right">
                    <span className="form_span" style={{width: "auto"}}>{Strings.rs10177 || Strings.current} {dataSource.length}</span>
                </div>:null}
                {!hideTable || hasList ?
                <div className="modal_item wwtable" >
                    <WWTable className={"new_app_table"}  columns={Tools.isDeviceMgt(this.props.platform)?columns:columns_mic} innerHeight={350} height={0}
                        dataSource={dataSource}  pagination={false} hiddenPagination={true}/>
                </div>:null}
                <BatchCheckModal handleImeiSet={this.handleImeiSet} ref={'batchCheck'}/>
            </div>
        )
    }
}
export default AddDeviceList
